@if (isPopupOpen) {
  <div class="bm--bg-popup" (click)="closePopup()">
    <div class="info-popup__information" (click)="$event.stopPropagation()">
      <div class="info-popup__header">
        <p class="info-popup__title">{{ lg.infoPopup.title }}</p>
        <div class="btv-icon-close" (click)="closePopup()"></div>
      </div>
      <div class="info-popup__footer">
        <p class="info-popup__text">{{ lg.infoPopup.descr }}</p>
        <div class="info-popup__buttons">
          <div class="info-popup__btn-cancel">
            <bmcore-button
              title="{{ lg.infoPopup.btn.cancel }}"
              [styleName]="'center-grey'"
              (clickHandler)="closePopup()"
            >
            </bmcore-button>
          </div>
          <div class="info-popup__btn-login">
            <bmcore-button
              title="{{ lg.infoPopup.btn.authenticate }}"
              [styleName]="'center'"
              [routerPath]="appType === 'BMTV' ? '/login' : '/sign-in'"
              (clickHandler)="closePopup()"
            >
            </bmcore-button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
